export const MY_LISTS_ACTIONS = {
    openRecents: 'OPEN_RECENTS',
    openFavorites: 'OPEN_FAVORITES',
    openCollections: 'OPEN_COLLECTIONS',
    closePanel: 'CLOSE_PANEL'
};
